import React from "react";
import { useForm } from "react-hook-form";
import "twin.macro";
import axios from "axios";

const formData = [
  {
    label: "First Name",
    field: "firstName",
    placeholder: "John",
    reqd: "First name is required",
  },
  {
    label: "Last Name",
    field: "lastName",
    placeholder: "Doe",
    reqd: "Last name is required",
  },
  {
    label: "Email Address",
    field: "email",
    placeholder: "example@gmail.com",
    reqd: "Email is required",
  },
  {
    label: "Phone Number",
    field: "phone",
    placeholder: "1234567890",
    reqd: "Phone no. is required",
  },
  {
    label: "University Name",
    field: "university",
    placeholder: "University Name",
    reqd: "University name is required",
  },
];

const RegistrationForms = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data) => {
    alert("Registration completed successfully.");
    window.location.pathname = "/";
    axios
      .post(
        "https://sheet.best/api/sheets/936093d2-f31e-49f6-9f1f-4274322bc0cb",
        data
      )
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div tw="md:grid grid-cols-2 gap-x-4">
        {formData.map((item, index) => (
          <div tw="text-left flex flex-col py-2">
            <label tw="text-white">{item.label}</label>
            <input
              {...register(`${item.field}`, {
                required: true,
              })}
              placeholder={item.placeholder}
              tw="p-2 rounded text-gray-600 focus:(ring-2 ring-red-500 outline-none)"
            />
            <p tw=" text-red-600">{errors[item.field] && `${item.reqd}`}</p>
          </div>
        ))}

        <div tw="text-white flex flex-col text-left my-auto">
          <label>Select a Course</label>
          <select
            {...register("course", {
              required: true,
            })}
            tw="w-full p-2 text-gray-600 rounded focus:(ring-2 ring-red-500 outline-none)"
          >
            <option value="web">Web Development</option>
            <option value="graphic">Graphic Design</option>
            <option value="freelancing">Freelancing</option>
          </select>
          <p tw=" text-red-600">{errors.course && "Please select a course"}</p>
        </div>
      </div>

      <div tw="text-left py-2">
        <label>Course Expectation</label>
        <textarea
          {...register("textarea", {
            required: true,
          })}
          placeholder="What is your expectation from this course!"
          rows="6"
          tw="w-full focus:(ring-2 ring-red-500) rounded p-5 focus:outline-none text-gray-600"
        ></textarea>
        <p tw=" text-red-600">
          {errors.textarea && "Write your expectation from the course"}
        </p>
      </div>

      <div tw="mx-auto max-w-xs">
        <input
          type="submit"
          tw="w-full  bg-red-600 py-2 cursor-pointer rounded hover:bg-red-500 "
        />
      </div>
    </form>
  );
};

export default RegistrationForms;
